import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Form } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

import { grey } from 'lib/css/colors';
import ImagesDisplayModal from 'components/settings/support_tickets/ImagesDisplayModal';
function SupportTicketCommentBox({ comment, origin, onEditComment, canEdit }) {
  const [showCommentsAttachmentsModal, setShowCommentsAttachmentsModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editedComment, setEditedComment] = useState(comment.comment);

  const formatDate = timestamp => {
    const date = new Date(typeof timestamp === 'number' ? timestamp * 1000 : timestamp);
    return date
      .toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      })
      .replace(',', ' at');
  };

  const handleSaveEdit = () => {
    onEditComment(editedComment);
    setIsEditing(false);
  };

  const handleCancelEdit = () => {
    setEditedComment(comment.comment);
    setIsEditing(false);
  };

  return (
    <div className={css(styles.commentBox)}>
      <div className={css(styles.commentHeader)}>
        <div>
          <strong>{comment.commented_by}</strong>
          <span className="text-muted ml-2">{formatDate(comment.timestamp)}</span>
        </div>
        {canEdit && !isEditing && (
          <Button
            variant="link"
            className={css(styles.editButton)}
            onClick={() => setIsEditing(true)}
          >
            <FontAwesomeIcon icon={faEdit} />
          </Button>
        )}
      </div>
      {isEditing ? (
        <div className={css(styles.editContainer)}>
          <Form.Control
            as="textarea"
            rows={3}
            value={editedComment}
            onChange={e => setEditedComment(e.target.value)}
            className={css(styles.editTextarea)}
          />
          <div className={css(styles.editActions)}>
            <Button size="sm" onClick={handleSaveEdit} className="mr-2">
              <FontAwesomeIcon icon={faSave} /> Save
            </Button>
            <Button variant="secondary" size="sm" onClick={handleCancelEdit}>
              <FontAwesomeIcon icon={faTimes} /> Cancel
            </Button>
          </div>
        </div>
      ) : (
        <div>{comment.comment}</div>
      )}
      {comment.attachments.length > 0 && (
        <>
          <Button
            variant="link"
            className="p-0 mt-1"
            onClick={() => setShowCommentsAttachmentsModal(true)}
          >
            View {comment.attachments.length} Attachments
          </Button>
          {showCommentsAttachmentsModal && (
            <ImagesDisplayModal
              images={comment.attachments.map(imageUrl => ({
                url: imageUrl,
              }))}
              onHide={() => setShowCommentsAttachmentsModal(false)}
              origin={origin}
            />
          )}
        </>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  commentBox: {
    borderBottom: `1px solid ${grey}`,
    paddingBottom: '10px',
    marginBottom: '10px',
  },
  commentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  editButton: {
    padding: '0',
    color: grey,
  },
  editContainer: {
    marginTop: '8px',
  },
  editTextarea: {
    marginBottom: '8px',
  },
  editActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

SupportTicketCommentBox.propTypes = {
  comment: PropTypes.object.isRequired,
  origin: PropTypes.string,
  onEditComment: PropTypes.func,
  canEdit: PropTypes.bool,
};

export default SupportTicketCommentBox;
